import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/bob/solution_back.webp";

function Solutionbob() {
  return (
    <section
      className="solution_bob text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={10} lg={8} xl={8} xxl={8} className="my-auto">
            <h2>
              Tekrevol’s Solution to Creating A Robust Business Listing Mobile
              Application
            </h2>
            <p>
              Tekrevol thoroughly studied all the ins and outs of a business
              listing app. We created the perfect business listing app for our
              customer’s targeted audience. From intuitive navigation that
              allowed the user to skim through numerous pages to relevant
              details to the user about a business, the B.O.B app had everything
              our client and audience required. Moreover, the business directory
              system integrated into the B.O.B app provided the users with
              several different tools to professionally maintain their ongoing
              log and business record. To find the information about a company,
              the users could select specific filters within the app.
              Additionally, by integrated G.P.S. into the business listing app,
              the users could get directions to visit a company, resulting in
              more conversion opportunities. The users could also search for
              companies operating within their specific areas.
            </p>
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/bob/solution_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={881}
                height={654}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionbob;
